import React from 'react';
import { Box } from '@mui/material';
import { ColumnFlexBox } from '../../FlexBox';
import DonutStat from './DonutStat';
import OutcomeBars from './OutcomeBars';

/**
 * DonutBreakdown — the donut sits centered on top and stays visible while the
 * outcome legend below it scrolls (mockup screen 9). `items: [{ label, value,
 * color }]` where value is a percentage.
 */
const DonutBreakdown = function DonutBreakdown({
  items = [],
  centerValue = null,
  centerLabel = null,
}) {
  return (
    <ColumnFlexBox sx={{ alignItems: 'center', gap: 1.75 }}>
      <DonutStat
        segments={items}
        centerValue={centerValue}
        centerLabel={centerLabel}
        size={140}
      />
      <Box
        className="scr"
        sx={{ width: '100%', maxHeight: 176, overflowY: 'auto' }}
      >
        <OutcomeBars items={items} />
      </Box>
    </ColumnFlexBox>
  );
};

export default DonutBreakdown;
